import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function OnboardingGuard() {
  const hasSeenOnboarding = localStorage.getItem("hasSeenOnboarding");
  const location = useLocation();

  // allow onboarding page itself
  if (!hasSeenOnboarding && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
}
